// extracted by mini-css-extract-plugin
module.exports = {"wcqghgw":"wcqghgw","tsv3qdc":"tsv3qdc","d1428o7t":"d1428o7t"};